import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ButtonGroup, Button, Form, Offcanvas, InputGroup, Col, Row } from "react-bootstrap";
import { Account, useAppDispatch, useAppSelector, usePutDeviceKeyRotationMutation, PublicRoutes, usePostUsersFindMutation, filesyncSocketApi, useDeleteUsersMutation, useExpireUsersDevicesKeysMutation } from "src/common";
import { Icon } from "src/components";
import MailModalSandbox from "./MailModalSandbox.component";
import { uiActions, websocketActions } from "src/store";
import { RootState } from "src/store/configureStore";

// NOTE: Switch this to true to activate the OffCanvasDevToolsComponent, BUT Save as false before committing
const activate_off_canvas = false;
const activate_mail_modal = false; // NOTE: Switch to true to activate the send mail modal
function OffCanvasDevToolsComponent() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const current_account = useAppSelector((state: RootState) => state.account.current_account);
  const user_id = current_account?.user_id;
  const [show, setShow] = useState(activate_off_canvas);
  const [hide_tools, setHideTools] = useState(!activate_off_canvas);
  const [show_mail, setShowMail] = useState(activate_off_canvas && activate_mail_modal);
  const [delete_user_id, setDeleteUserId] = useState<string>("");
  const [rotateKey] = usePutDeviceKeyRotationMutation();
  const [findUsers] = usePostUsersFindMutation();
  const [deleteUser] = useDeleteUsersMutation();
  const [expireKey] = useExpireUsersDevicesKeysMutation();
  const [closeFSNotificationsWs] = filesyncSocketApi.useCloseFSNotificationSocketMutation();
  const [closeDriveWs] = filesyncSocketApi.useCloseSocketMutation();
  const [closeDriveNotificationWs] = filesyncSocketApi.useCloseNotificationSocketMutation();
  const [closeWatchWs] = filesyncSocketApi.useCloseWatchSocketMutation();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Description: Rotate device key for testing
  function TriggerCryptoKeyRotation() {
    !!user_id && rotateKey({ userId: user_id }).unwrap()
      .then(() => {
        setShow(false);
      });
  }

  // Description: Find User in CS
  async function handleFindUserCS() {
    if (!!current_account) {
      findUsers({
        account_ids: Account.getAccountIdentifiers(current_account),
        body: { spec: [{ user_id, key_version: -1 }] }
      }).unwrap()
        .then((_response: any) => {
        })
        .catch((errors: unknown) => {
          console.log("catch: ", errors);
        });
    }
  }

  // Description: Delete user
  function handleDeleteUserIdCS() {
    if (!!current_account && !!delete_user_id) {
      deleteUser({
        account_ids: Account.getAccountIdentifiers(current_account),
        body: { user_id: delete_user_id }
      }).unwrap()
        .then((response: any) => {
          console.log(response);
          navigate(`/${PublicRoutes.logout_route}`);
        })
        .catch((errors: unknown) => {
          console.log("catch: ", errors);
        });
    }
  }

  // Description: Trigger Device Key Expiration for Express accounts
  // https://github.com/PreVeil/core/blob/dev/collection_server/docs/device_keys.md#post-usersdeviceskeysdevice_idexpire
  function handlExpireDeviceKeyCS() {
    console.log("handlExpireDeviceKeyCS");
    if (!!current_account) {
      const device_id = current_account.current_device_id;
      expireKey({
        account_ids: Account.getAccountIdentifiers(current_account),
        body: {
          device_id
        }
      }).unwrap()
        .then((response: any) => {
          console.log(response);

        })
        .catch((errors: unknown) => {
          console.log("catch: ", errors);
        });
    }
  }

  return <>
    {/* Remove d-none to have the dev tools off canvas avail */}
    <ButtonGroup className={`dev-tools ${hide_tools ? "d-none" : ""}`}>
      <Button variant="info" className="btn-icon" onClick={handleShow}>
        <Icon className="pv-icon-chevron-up" />
      </Button>
      <Button variant="secondary" className="btn-icon" onClick={() => setHideTools(true)}>
        <Icon className="pv-icon-close" />
      </Button>
    </ButtonGroup>
    <Offcanvas show={show} onHide={handleClose} placement="bottom"
      backdrop={false}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Dev Tools</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="py-0">
        <div className="btn-panel my-2">
          <Button size="sm" onClick={TriggerCryptoKeyRotation}>Trigger Crypto Key Rotation</Button>
          <Button size="sm" onClick={handlExpireDeviceKeyCS}>Expire Device Key (CS)</Button>
          <Link className="btn btn-primary btn-sm" to={`/${PublicRoutes.logout_route}`}>
            Logout
          </Link>
          <Button size="sm" onClick={handleFindUserCS}>Find Users CS Call</Button>
          <Button
            size="sm"
            onClick={() => {
              dispatch(uiActions.handleSetDirtyMessage(true));
            }}>  Dirty Warning</Button>
          <Button
            size="sm"
            onClick={() => setShowMail(true)}>Show Mail</Button>
        </div>
        <Row>
          <Col sm={3}>
            <InputGroup size="sm">
              <Form.Control
                id="user_id_tb"
                type="text"
                name="user_id"
                value={delete_user_id}
                onChange={(e: React.FocusEvent<HTMLInputElement>) => setDeleteUserId(e.currentTarget.value)}
              />
              <Button
                size="sm"
                tabIndex={-1}
                onClick={handleDeleteUserIdCS}>Delete</Button>

            </InputGroup>
          </Col>
          <Col>
            <ButtonGroup size="sm">

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  dispatch(websocketActions.wsNotifyDestroy());
                }}>Notify_ws Off</Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  console.log("DESTROY or Disconnect Subscribe WS");
                  closeFSNotificationsWs(new Date().getTime().toString());
                }}>subscribe_ws Off</Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  closeDriveWs(new Date().getTime().toString());
                  console.log("DESTROY or Disconnect Collection WS");
                }}>collection_ws Off</Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  closeDriveNotificationWs(new Date().getTime().toString());
                  console.log("DESTROY or Disconnect Collection WS");
                }}>Drive Notifications Off</Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  console.log("DESTROY or Disconnect Collection WS watched");
                  closeWatchWs(new Date().getTime().toString());
                }}>Watch WS  Off</Button>
            </ButtonGroup>
          </Col>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
    {
      !!current_account &&
      <MailModalSandbox
        current_account={current_account}
        show_mail={show_mail}
        setShowMail={setShowMail}
      />
    }
  </>;
}

export default React.memo(OffCanvasDevToolsComponent);